import { CameraAltRounded } from "@mui/icons-material";
import GroupsIcon from "@mui/icons-material/Groups";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import type React from "react";
import { forwardRef } from "react";

interface InputProfileGroupsProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	image?: string;
}

const InputProfileGroups = forwardRef<
	HTMLInputElement,
	InputProfileGroupsProps
>(({ image, ...props }, ref) => {
	return (
		<Box
			component="label"
			htmlFor={props.name}
			className="relative w-24 h-24 cursor-pointer"
		>
			{image ? (
				<Box className="h-full w-full rounded-full overflow-hidden bg-gray-300">
					<img
						className="h-full w-full object-cover"
						src={image}
						alt="avatar"
					/>
				</Box>
			) : (
				<Avatar className="!h-full !w-full !bg-gray-300 !text-dark">
					<GroupsIcon className="!h-10 !w-10 object-center" />
				</Avatar>
			)}
			<Box className="absolute bottom-0 right-0 w-8 h-8 bg-white rounded-full flex items-center justify-center p-2">
				<input
					id={props.name}
					type="file"
					accept="image/*"
					className="hidden"
					aria-label="Profile Picture"
					ref={ref}
					{...props}
				/>
				<CameraAltRounded className="text-gray-600" />
			</Box>
		</Box>
	);
});

export default InputProfileGroups;
